module.exports = __webpack_public_path__ + "img/FE_A2_front_en.9f3b00cc.png";